// Store Version: 1.1 - Cleaned up unused functions (2024-02-12)
// Previous version (1.0) available in git history if rollback needed
import { create } from "zustand"

type FrameState = "open" | "closed" | "outside"

interface ShelvingState {
  model: string
  setModel: (model: string) => void

  height: number
  width: number
  depth: number
  sides: "single" | "double"
  setHeight: (height: number) => void
  setWidth: (width: number) => void
  setDepth: (depth: number) => void
  setSides: (sides: "single" | "double") => void

  shelfCount: number
  sectionCount: number
  setShelfCount: (count: number) => void
  setSectionCount: (count: number) => void
  incrementSectionCount: () => void
  decrementSectionCount: () => void
  frameState: FrameState
  setFrameState: (state: FrameState) => void

  showAxisHelper: boolean
  toggleAxisHelper: () => void

  showShadows: boolean
  toggleShadows: () => void

  showFloor: boolean
  toggleFloor: () => void

  gradientBackground: boolean
  toggleGradientBackground: () => void

  shelfLoadPerShelf: number
  setShelfLoadPerShelf: (load: number) => void

  showBOMDialog: boolean
  setShowBOMDialog: (show: boolean) => void

  showOrderDialog: boolean
  setShowOrderDialog: (show: boolean) => void

  showDimensions: boolean
  toggleDimensions: () => void
}

export const useShelvingStore = create<ShelvingState>((set, get) => ({
  model: "L2505",
  setModel: (model) => set({ model }),

  height: 200,
  width: 97,
  depth: 40,
  sides: "single",
  setHeight: (height) => set({ height }),
  setWidth: (width) => set({ width }),
  setDepth: (depth) => set({ depth }),
  setSides: (sides) => set({ sides }),

  shelfCount: 5,
  sectionCount: 1,
  setShelfCount: (count) => set({ shelfCount: count }),
  setSectionCount: (count) => set({ sectionCount: count }),
  incrementSectionCount: () => set((s) => ({ sectionCount: s.sectionCount + 1 })),
  decrementSectionCount: () => set((s) => ({ sectionCount: Math.max(1, s.sectionCount - 1) })),
  frameState: "open",
  setFrameState: (frameState) => set({ frameState }),

  showAxisHelper: false,
  toggleAxisHelper: () => set((s) => ({ showAxisHelper: !s.showAxisHelper })),

  showShadows: false,
  toggleShadows: () => set((s) => ({ showShadows: !s.showShadows })),

  showFloor: false,
  toggleFloor: () => set((s) => ({ showFloor: !s.showFloor })),

  gradientBackground: true,
  toggleGradientBackground: () => set((s) => ({ gradientBackground: !s.gradientBackground })),

  shelfLoadPerShelf: 0,
  setShelfLoadPerShelf: (load) => set({ shelfLoadPerShelf: load }),

  showBOMDialog: false,
  setShowBOMDialog: (show) => set({ showBOMDialog: show }),

  showOrderDialog: false,
  setShowOrderDialog: (show) => set({ showOrderDialog: show }),

  showDimensions: false,
  toggleDimensions: () => set((s) => ({ showDimensions: !s.showDimensions })),
}))